import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {BaseApi} from "../../services/BaseApi";
import {Resource} from "../model/resource";
import {HttpClient} from "@angular/common/http";
import {Session} from "../../services/session";
import {Store} from "@ngrx/store";
import {AppState} from "../../actions/reducers";
import {catchError, map} from "rxjs/operators";
import {ResourceGroup} from "../model/resource-group";

export interface ResourceGroupUpate {
  name: string,
}

@Injectable()
export class ResourceGroupsApi extends BaseApi {
  constructor(protected http: HttpClient, protected session: Session, protected store: Store<AppState>) {
    super(http, session, store);
  }

  public getAll(): Observable<ResourceGroup[]> {
    let serviceProvider = this.getServiceProviderIdentifier();
    let url = `/api/v2/tyrael/sp/${serviceProvider}/resource-group`;
    return this.http
      .get(url, {headers: this.getHeaders()})
      .pipe(
        catchError(err => this.handleNetworkError(err)),
        map(response => {
          return (<any>response).map(ResourceGroup.fromJson);
        }),
      )
  }

  getById(id: string): Observable<ResourceGroup> {
    let serviceProvider = this.getServiceProviderIdentifier();
    let url = `/api/v2/tyrael/sp/${serviceProvider}/resource-group/${id}`;
    return this.http
      .get(url, {headers: this.getHeaders()})
      .pipe(
        catchError(err => this.handleNetworkError(err)),
        map(response => ResourceGroup.fromJson(response)),
      )
  }

  update(id: string, resource: ResourceGroupUpate): Observable<any> {
    let serviceProvider = this.getServiceProviderIdentifier();
    let url = `/api/v2/tyrael/sp/${serviceProvider}/resource-group/${id}`;
    return this.http
      .put(url, resource, {headers: this.getHeaders()})
      .pipe(
        catchError(err => this.handleNetworkError(err)),
        map(response => Resource.fromJson(response))
      )
  }

  create(resource: ResourceGroupUpate): Observable<Resource> {
    let serviceProvider = this.getServiceProviderIdentifier();
    let url = `/api/v2/tyrael/sp/${serviceProvider}/resource-group`;
    return this.http
      .post(url, resource, {headers: this.getHeaders()})
      .pipe(
        catchError(err => this.handleNetworkError(err)),
        map(response => Resource.fromJson(response))
      )
  }

  delete(id: string) {
    let serviceProvider = this.getServiceProviderIdentifier();
    let url = `/api/v2/tyrael/sp/${serviceProvider}/resource-group/${id}`;
    return this.http
      .delete(url, {headers: this.getHeaders()})
      .pipe(
        catchError(err => this.handleNetworkError(err)),
      )
  }
}
